<script setup>
// Shell de modal reutilizável do módulo Atendimentos (overlay + caixa + header + footer).
defineProps({
  title: { type: String, default: '' },
  size: { type: String, default: 'md' },
});
const emit = defineEmits(['close']);
</script>

<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-n-alpha-black2"
    @click.self="emit('close')"
  >
    <div
      class="bg-n-background rounded-xl shadow-xl max-h-[92vh] overflow-y-auto max-w-full"
      :class="
        size === 'sm'
          ? 'w-[26rem]'
          : size === 'lg'
            ? 'w-[46rem]'
            : 'w-[32rem]'
      "
    >
      <div class="flex items-center justify-between p-5 border-b border-n-weak">
        <h2 class="text-heading-2 text-n-slate-12">{{ title }}</h2>
        <button
          class="text-n-slate-10 hover:text-n-slate-12"
          @click="emit('close')"
        >
          <svg
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="p-5 space-y-3"><slot /></div>
      <div class="flex justify-end gap-3 p-5 border-t border-n-weak">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
